import { MT4_PLATFORM, MT4_2_PLATFORM, MT5_PLATFORM } from 'constants/index';

export const isMetatraderPlatform = (platform) => {
  return platform === MT4_PLATFORM || platform === MT4_2_PLATFORM || platform === MT5_PLATFORM;
};
